import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';

import {MonetaryArea} from '../../../parameters/monetary-areas/monetary-area.model';
import {RequestParameters} from '../../models/request-parameters/parameter.model';
import {MonetaryAreaService} from '../../../parameters/monetary-areas/monetary-area.service';

@Component({
  selector: 'app-monetary-areas-autocomplete',
  templateUrl: './monetary-areas-autocomplete.component.html',
  styleUrls: ['./monetary-areas-autocomplete.component.scss']
})
export class MonetaryAreasAutocompleteComponent implements OnInit {

  @Input('monetaryAreaFormControl') monetaryAreaFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Output() onMonetaryAreaSelected: EventEmitter<MonetaryArea> = new EventEmitter<MonetaryArea>();

  @ViewChild('autoMonetaryAreas') autoMonetaryAreas: ElementRef;

  monetaryAreas: Observable<any> = new Observable<any>();
  monetaryAreaLoading: boolean = true;
  monetaryAreaParameters: RequestParameters = new RequestParameters();

  constructor(private monetaryAreaService: MonetaryAreaService) {
    this.updateMonetaryAreas();
  }

  ngOnInit() {
  }

  onSelectMonetaryArea() {
    this.onMonetaryAreaSelected.emit(this.monetaryAreaFormControl.value);
  }

  displayMonetaryAreas (monetaryArea: MonetaryArea) {
    if (monetaryArea !== null) {
      return monetaryArea.name && monetaryArea.currencyLongName && monetaryArea.currencyCode? monetaryArea.name + ' - ' + monetaryArea.currencyLongName + ' - ' +monetaryArea.currencyCode:monetaryArea.name;
    }
  }

  filterMonetaryAreas (filterInput: string = '') {
    if (this.monetaryAreaParameters.searchString !== filterInput) {
      this.monetaryAreaParameters.searchString = filterInput;
      this.updateMonetaryAreas();
    }
  }

  updateMonetaryAreas () {
    this.monetaryAreaLoading = true;
    this.monetaryAreas = this.monetaryAreaService.getMonetaryAreas(this.monetaryAreaParameters)
      .map(
        (response) => {
          this.monetaryAreaLoading = false;
          return response.result;
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/monetary-areas-autocomplete/monetary-areas-autocomplete.component.ts